import { useEffect, useState } from 'react';
import { Pie } from 'react-chartjs-2';
import { Card } from '@mui/material';
import { backgroundColor, subTitleFont, titleColor, titleFont, titlePadding } from './charts-data-config';

export default function ChartPie({ chartData, legendPlacement, cardWidth, cardHeight, chartHeight }: any) {
  const [colors, setColors] = useState(backgroundColor);
  const chartLegendPlacement = legendPlacement || 'top';
  const chartCardWidth = cardWidth || 350;
  const chartCardHeight = cardHeight || 350;
  const chartChartHeight = chartHeight || 350;

  useEffect(() => {
    if (chartData.quality) {
      const qualityColors: string[] = [];
      chartData.labels.forEach((value: any, index: number) => {
        if (value.includes('0_unknown')) {
          qualityColors.push('#94A2B0');
        } else if (value.includes('1_good')) {
          qualityColors.push('#93B37A');
        } else if (value.includes('2_ok')) {
          qualityColors.push('#E1BC66');
        } else if (value.includes('3_bad')) {
          qualityColors.push('#d77947');
        } else if (value.includes('4_terrible')) {
          qualityColors.push('#E05D5F');
        }
      }); 
      setColors(qualityColors);
    }
  }, [chartData]);

  useEffect(() => {
    if (chartData.navigatorVersion) {
      const versionColors: string[] = [];
      chartData.labels.forEach((value: any, index: number) => {
        versionColors.push(`rgb(${Math.floor(Math.random() * 255)},${Math.floor(Math.random() * 255)},${Math.floor(Math.random() * 255)})`);
      });
      setColors(versionColors);
    }
  }, [chartData.navigatorVersion]);

  return (
    <Card sx={{ width: chartCardWidth, height: chartCardHeight }}>
      <Pie
        height={chartChartHeight}
        data={{
          labels: chartData.labels,
          datasets: [
            {
              data: chartData.data,
              backgroundColor: colors,
              borderColor: 'white',
              borderWidth: 1,
            },
          ],
        }}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            subtitle: {
              display: chartData.displaySubtitle,
              text: chartData.subtitle,
              font: subTitleFont,
            },
            title: {
              display: chartData.displayTitle,
              text: chartData.title,
              font: titleFont,
              color: titleColor,
              padding: titlePadding,
            },
            legend: {
              position: chartLegendPlacement,
            },
          },
        }}
      />
    </Card>
  );
}
